module.exports = __webpack_public_path__ + "static/media/popup-grow.08953c16.wav";